import * as Styled from "./LoginButton.styled";

/**
 * Returns the styled button component for the given code.
 * Falls back to LoginButtonStyled for unknown/missing codes so all
 * Step1/Step2 integrations can use LoginButton without a specific code.
 */
export const getLoginButtonComponentWithCode = (code?: string) => {
    const handlers = [
        {
            predicate: () => code === "bigquery",
            handler: () => Styled.BigqueryLoginButtonStyled,
        },
        {
            predicate: () => code === "google-sheets" || code === "google",
            handler: () => Styled.GoogleSheetsLoginButtonStyled,
        },
        {
            predicate: () => code === "hubspot",
            handler: () => Styled.HubspotLoginButtonStyled,
        },
        {
            predicate: () => code === "dynamics",
            handler: () => Styled.DynamicsLoginButtonStyled,
        },
        {
            predicate: () => code === "salesforce",
            handler: () => Styled.SalesforceLoginButtonStyled,
        },
        {
            predicate: () => code === "zoho",
            handler: () => Styled.ZohoLoginButtonStyled,
        },
        {
            predicate: () => code === "monday",
            handler: () => Styled.MondayLoginButtonStyled,
        },
        {
            predicate: () => code === "zendesk_sell",
            handler: () => Styled.ZendeskLoginButtonStyled,
        },
        {
            predicate: () => code === "pipedrive",
            handler: () => Styled.PipedriveLoginButtonStyled,
        },
        {
            predicate: () => code === "b24",
            handler: () => Styled.B24LoginButtonStyled,
        },
        {
            predicate: () => code === "linkedin",
            handler: () => Styled.LinkedinLoginButtonStyled,
        },
        {
            predicate: () => code === "tiktok",
            handler: () => Styled.TiktokLoginButtonStyled,
        },
        {
            predicate: () => code === "pinterest",
            handler: () => Styled.PinterestLoginButtonStyled,
        },
        {
            predicate: () => code === "reddit",
            handler: () => Styled.RedditLoginButtonStyled,
        },
        {
            predicate: () => code === "msoffline" || code === "microsoft",
            handler: () => Styled.MsofflineLoginButtonStyled,
        },
        {
            predicate: () => code === "ymwc",
            handler: () => Styled.YandexLoginButtonStyled,
        },
    ];

    const found = handlers.find(({ predicate }) => predicate());
    return found ? found.handler() : Styled.LoginButtonStyled;
};
